import { render, staticRenderFns } from "./CorrectErrorView.vue?vue&type=template&id=773cceec&scoped=true&"
import script from "./CorrectErrorView.vue?vue&type=script&lang=js&"
export * from "./CorrectErrorView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773cceec",
  null
  
)

export default component.exports